// extracted by mini-css-extract-plugin
export var container = "index-module--container--EPC5e";
export var item = "index-module--item---SE5B";
export var list = "index-module--list--18pzh";
export var paragraph = "index-module--paragraph--m2a9X";
export var privacy = "index-module--privacy--2PmTt";